module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noData":"There are no customers saved locally.","all":"All"},"es":{"noData":"No hay agricultores, contactos u otros perfiles guardados localmente.","all":"Todos"},"sw":{"noData":"Hakuna mkulima, mawasiliano au wasifu mwingine uliookolewa ndani.","all":"Kila Mtu"}}')
  delete Component.options._Ctor
}
